import React from "react";
import EventManager from "./EventManager";

const EventManagerContext = React.createContext<EventManager>(new EventManager());
EventManagerContext.displayName = "EventManagerContext";

export default EventManagerContext;